// extracted by mini-css-extract-plugin
export default {"closeIconContainer":"close-dialog_closeIconContainer__prOd-"};